export default "__VITE_ASSET__DcOp7Zuc__"